<template>
    <div>
        <component :is="component" :method="method" :plan="plan"></component>
    </div>
</template>

<script>
    import Pagarme from "../components/PaymentGateways/Pagarme/Pagarme.vue";
    import Iugu from "../components/PaymentGateways/Iugu/Iugu.vue";
    import Stripe from "../components/PaymentGateways/Stripe.vue";
    import Paypal from "../components/PaymentGateways/Paypal.vue";
    import Deposit from "../components/PaymentGateways/Deposit.vue";
    import Paymee from "../components/PaymentGateways/Paymee/Paymee.vue";
    import PaymeePix from "../components/PaymentGateways/Paymee/PaymeePix.vue";

    export default {
        props: {
            plan: String,
            component: String,
            method: String
        },

        components: {
            Paypal,
            Stripe,
            Pagarme,
            Deposit,
            Iugu,
            Paymee,
            PaymeePix
        },

        methods: {
            callPaymentApi(plan, options = {}) {
                return new Promise((resolve, reject) => {
                    if (window.PaymentRequest) {
                        const methodData = [
                            {
                                supportedMethods: [
                                    'basic-card'
                                ],
                                data: {
                                    supportedNetworks: [
                                        'amex', 'diners', 'discover', 'jcb', 'maestro', 'mastercard', 'unionpay', 'visa',
                                        'elo'
                                    ]
                                }
                            }
                        ];

                        options = Object.assign({
                            requestPayerPhone: true,
                            requestPayerEmail: true,
                            requestPayerName:  true
                        }, options);

                        const details = {
                            displayItems: [
                                {
                                    label: plan.name,
                                    amount: { currency: plan.currency, value : plan.amount }
                                }
                            ],
                            total:  {
                                label: this.$t('total'),
                                amount: {
                                    currency: plan.currency,
                                    value: plan.amount
                                }
                            }
                        };

                        let request = new window.PaymentRequest(
                            methodData,
                            details,    // required information about transaction
                            options     // optional parameter for things like shipping, etc.
                        );

                        request
                            .show()
                            .then((res) => {
                                resolve(res);
                            })
                            .catch(reject);
                    } else {
                        reject('unsupported');
                    }
                })

            }
        }
    }
</script>